"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Title = _styledComponents["default"].span.withConfig({
  displayName: "header__Title",
  componentId: "sc-1xiulv2-0"
})(["letter-spacing:0.3px;"]);

var propTypes = {
  /** Array of objs for Cta links */
  links: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Defaults to an anchor tag if a url prop is present and a <button> tag otherwise */
    tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.node]),

    /** Target for cta links, used for opening a new tab or window */
    target: _propTypes.string,

    /** text prop is a children node for cta */
    text: _propTypes.node,

    /** Url provided to CtaContainer for links */
    url: _propTypes.string
  })),

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** Title font object  */
  titleFont: _utils.fontPropType
};

var RecommendedToolsHeader = function RecommendedToolsHeader(_ref) {
  var links = _ref.links,
      title = _ref.title,
      titleFont = _ref.titleFont;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: [6, 8, 12, 3, 3, 3]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center",
    width: 1
  }, title && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    tag: "h2",
    textAlign: "center",
    width: 1
  }, titleFont), /*#__PURE__*/_react["default"].createElement(Title, null, title)), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: ["column", "row", "row", "column"],
    justifyContent: ["center", "flex-start", "flex-start", "center"],
    width: 1
  }, (0, _utils.mapIndexed)(function (_ref2, index) {
    var tag = _ref2.tag,
        target = _ref2.target,
        text = _ref2.text,
        url = _ref2.url;
    return /*#__PURE__*/_react["default"].createElement(_components.Cta, {
      key: index,
      fontWeight: 2,
      glyphRight: /*#__PURE__*/_react["default"].createElement(_components.NavCaretRight, null),
      iconSize: 16,
      letterSpacing: "0.5px",
      lineHeight: 3,
      mb: [index === links.length - 1 ? 0 : 1],
      mr: [0, 3, 3, 0, 0],
      tag: tag,
      target: target,
      url: url,
      version: "link"
    }, text);
  }, links))));
};

RecommendedToolsHeader.propTypes = propTypes;
RecommendedToolsHeader.displayName = "Modules.RecommendedToolsHeader";
var _default = RecommendedToolsHeader;
exports["default"] = _default;